import React, { useState } from 'react';
import { Formik } from 'formik';
import { Container, Row, Col, Form } from 'react-bootstrap';
import AutoSuggestionSelectComponent from '../common/AutoSuggestSelect/Select';
import TextInput from '../../../Components/GenericInputText/TextInput';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const SecurityQuestion = ({
  currentStep,
  nextStep,
  securityQuestionschema,
  selectedQuestionValues,
  handleQuestionValChange,
  formData,
  handleInput,
  isButtonDisable,
}) => {
  const questionOptions = [
    {
      value: 'What city were you born in?',
      label: 'What city were you born in?',
    },
    {
      value: 'What is your oldest sibling’s middle name?',
      label: 'What is your oldest sibling’s middle name?',
    },
    {
      value: 'What was the make and model of your first car?',
      label: 'What was the make and model of your first car?',
    },
    {
      value: 'What was the name of your first manager at your first job?',
      label: 'What was the name of your first manager at your first job?',
    },
    {
      value: 'What was your favorite subject in high school?',
      label: 'What was your favorite subject in high school?',
    },
  ];

  const [qusetionOptionsAvailable, setusetionOptionsAvailable] =
    useState(questionOptions);

  const getRemainingOptions = () => {
    const remainingOptions = qusetionOptionsAvailable;
    const remainingOpt = remainingOptions.filter((question) => {
      return selectedQuestionValues.indexOf(question) === -1;
    });
    remainingOpt.push({
      value: 'Others',
      label: 'Others',
    });
    return remainingOpt;
  };

  return currentStep === 3 ? (
    <Container className="security-question-container">
      <Row>
        <Col md={8} className="security-question-form-container">
          <Row className="mb-4">
            <Col md={12}>
              <p>
                Select three security questions below. These questions will help
                us verify your identity should you to recover your password if
                you ever forget it.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Formik
                validationSchema={securityQuestionschema}
                initialValues={{
                  question1: selectedQuestionValues[0],
                  question2: selectedQuestionValues[1],
                  question3: selectedQuestionValues[2],
                  answer1: '',
                  answer2: '',
                  answer3: '',
                  customQuestion1: '',
                  customQuestion2: '',
                  customQuestion3: '',
                }}
                onSubmit={(values, actions) => {
                  nextStep();
                }}
              >
                {({
                  values,
                  touched,
                  errors,
                  status,
                  handleSubmit,
                  handleChange,
                  isValid,
                  handleBlur,
                  setStatus,
                  setFieldValue,
                  setFieldTouched,
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col sm={12}>
                          <Form.Group className="position-relative mb-0">
                            <Form.Label className="mb-2">
                              Security Question 1{' '}
                              <span className="form-required">*</span>
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={getRemainingOptions()}
                              name="question1"
                              placeholder="Select a Security Question"
                              components={{ IndicatorSeparator: () => null }}
                              value={selectedQuestionValues[0]}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'question1', value: e },
                                };
                                handleQuestionValChange(e, 0);
                                handleChange(event);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.question1 && errors.question1
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isRequired={true}
                              isInvalid={touched.question1 && errors.question1}
                            />
                            <div className="invalid-error">
                              {touched.question1 && errors.question1}
                            </div>
                          </Form.Group>
                          <Form.Group className="position-relative mb-0 mt-4">
                            {values.question1 &&
                              values.question1?.value &&
                              values.question1?.value === 'Others' && (
                                <TextInput
                                  isRequired={true}
                                  label="Enter Question"
                                  inputProps={{
                                    type: 'text',
                                    spellCheck: 'off',
                                    autoCorrect: 'off',
                                    autoComplete: 'off',
                                    autoFocus: false,
                                    onBlur: (e) => {
                                      //call the built-in handleChange for formik
                                      handleBlur(e);
                                      //and do something about e
                                      const customQuestion1Val =
                                        e.currentTarget.value.trim();
                                      setFieldValue(
                                        'customQuestion1',
                                        customQuestion1Val,
                                      );
                                    },
                                    onChange: (e) => {
                                      handleInput(
                                        e,
                                        setFieldValue,
                                        handleChange,
                                      );
                                    },
                                    name: 'customQuestion1',
                                    id: 'customQuestion1',
                                    value: formData.customQuestion1,
                                    placeholder: '',
                                    isInvalid:
                                      touched.customQuestion1 &&
                                      errors.customQuestion1,
                                  }}
                                  feedBackMessage={
                                    touched.customQuestion1 &&
                                    errors.customQuestion1
                                  }
                                  ariaInvalid={
                                    errors.customQuestion1 ? true : null
                                  }
                                  ariaDescribedby="err_customQuestion1"
                                />
                              )}
                          </Form.Group>
                          <Form.Group className="position-relative mb-0 mt-4">
                            <TextInput
                              isRequired={true}
                              label="Enter Answer"
                              className="mb-0 mt-4"
                              inputProps={{
                                type: 'text',
                                spellCheck: 'off',
                                autoCorrect: 'off',
                                autoComplete: 'off',
                                autoFocus: false,
                                onBlur: (e) => {
                                  //call the built-in handleChange for formik
                                  handleBlur(e);
                                  //and do something about e
                                  const answer1Val =
                                    e.currentTarget.value.trim();
                                  setFieldValue('answer1', answer1Val);
                                },
                                onChange: (e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                },
                                name: 'answer1',
                                id: 'answer1',
                                value: formData.answer1,
                                placeholder: '',
                                isInvalid: touched.answer1 && errors.answer1,
                              }}
                              feedBackMessage={
                                touched.answer1 && errors.answer1
                              }
                              ariaInvalid={errors.answer1 ? true : null}
                              ariaDescribedby="err_answer1"
                            />
                          </Form.Group>
                          <Form.Group className="position-relative mb-0">
                            <Form.Label className="mb-2 mt-4">
                              Security Question 2{' '}
                              <span className="form-required">*</span>
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={getRemainingOptions()}
                              name="question2"
                              placeholder="Select a Security Question"
                              components={{ IndicatorSeparator: () => null }}
                              value={selectedQuestionValues[1]}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'question2', value: e },
                                };
                                handleQuestionValChange(e, 1);
                                handleChange(event);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.question2 && errors.question2
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isRequired={true}
                              isInvalid={touched.question2 || errors.question2}
                            />
                            <div className="invalid-error">
                              {touched.question2 && errors.question2}
                            </div>
                          </Form.Group>
                          <Form.Group className="position-relative mb-0 mt-4">
                            {values.question2 &&
                              values.question2?.value &&
                              values.question2?.value === 'Others' && (
                                <TextInput
                                  isRequired={true}
                                  label="Enter Question"
                                  inputProps={{
                                    type: 'text',
                                    spellCheck: 'off',
                                    autoCorrect: 'off',
                                    autoComplete: 'off',
                                    autoFocus: false,
                                    onBlur: (e) => {
                                      //call the built-in handleChange for formik
                                      handleBlur(e);
                                      //and do something about e
                                      const customQuestion2Val =
                                        e.currentTarget.value.trim();
                                      setFieldValue(
                                        'customQuestion2',
                                        customQuestion2Val,
                                      );
                                    },
                                    onChange: (e) => {
                                      handleInput(
                                        e,
                                        setFieldValue,
                                        handleChange,
                                      );
                                    },
                                    name: 'customQuestion2',
                                    id: 'customQuestion2',
                                    value: formData.customQuestion2,
                                    placeholder: '',
                                    isInvalid:
                                      touched.customQuestion2 &&
                                      errors.customQuestion2,
                                  }}
                                  feedBackMessage={
                                    touched.customQuestion2 &&
                                    errors.customQuestion2
                                  }
                                  ariaInvalid={
                                    errors.customQuestion2 ? true : null
                                  }
                                  ariaDescribedby="err_customQuestion2"
                                />
                              )}
                          </Form.Group>
                          <Form.Group className="position-relative mb-0 mt-4">
                            <TextInput
                              isRequired={true}
                              label="Enter Answer"
                              className="mb-0 mt-4"
                              inputProps={{
                                type: 'text',
                                spellCheck: 'off',
                                autoCorrect: 'off',
                                autoComplete: 'off',
                                autoFocus: false,
                                onBlur: (e) => {
                                  //call the built-in handleChange for formik
                                  handleBlur(e);
                                  //and do something about e
                                  const answer2Val =
                                    e.currentTarget.value.trim();
                                  setFieldValue('answer2', answer2Val);
                                },
                                onChange: (e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                },
                                name: 'answer2',
                                id: 'answer2',
                                value: formData.answer2,
                                placeholder: '',
                                isInvalid: touched.answer2 && errors.answer2,
                              }}
                              feedBackMessage={
                                touched.answer2 && errors.answer2
                              }
                              ariaInvalid={errors.answer2 ? true : null}
                              ariaDescribedby="err_answer2"
                            />
                          </Form.Group>
                          <Form.Group className="position-relative mb-0">
                            <Form.Label className="mb-2 mt-4">
                              Security Question 3{' '}
                              <span className="form-required">*</span>
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={getRemainingOptions()}
                              name="question3"
                              placeholder="Select a Security Question"
                              components={{ IndicatorSeparator: () => null }}
                              value={selectedQuestionValues[2]}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'question3', value: e },
                                };
                                handleQuestionValChange(e, 2);
                                handleChange(event);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.question3 && errors.question3
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isRequired={true}
                              isInvalid={touched.question3 && errors.question3}
                            />
                            <div className="invalid-error">
                              {touched.question3 && errors.question3}
                            </div>
                          </Form.Group>
                          <Form.Group className="position-relative mb-0 mt-4">
                            {values.question3 &&
                              values.question3?.value &&
                              values.question3?.value === 'Others' && (
                                <TextInput
                                  isRequired={true}
                                  label="Enter Question"
                                  inputProps={{
                                    type: 'text',
                                    spellCheck: 'off',
                                    autoCorrect: 'off',
                                    autoComplete: 'off',
                                    autoFocus: false,
                                    onBlur: (e) => {
                                      //call the built-in handleChange for formik
                                      handleBlur(e);
                                      //and do something about e
                                      const customQuestion3Val =
                                        e.currentTarget.value.trim();
                                      setFieldValue(
                                        'customQuestion3',
                                        customQuestion3Val,
                                      );
                                    },
                                    onChange: (e) => {
                                      handleInput(
                                        e,
                                        setFieldValue,
                                        handleChange,
                                      );
                                    },
                                    name: 'customQuestion3',
                                    id: 'customQuestion3',
                                    value: formData.customQuestion3,
                                    placeholder: '',
                                    isInvalid:
                                      touched.customQuestion3 &&
                                      errors.customQuestion3,
                                  }}
                                  feedBackMessage={
                                    touched.customQuestion3 &&
                                    errors.customQuestion3
                                  }
                                  ariaInvalid={
                                    errors.customQuestion3 ? true : null
                                  }
                                  ariaDescribedby="err_customQuestion3"
                                />
                              )}
                          </Form.Group>
                          <Form.Group className="position-relative mb-0 mt-4">
                            <TextInput
                              isRequired={true}
                              label="Enter Answer"
                              inputProps={{
                                type: 'text',
                                spellCheck: 'off',
                                autoCorrect: 'off',
                                autoComplete: 'off',
                                autoFocus: false,
                                onBlur: (e) => {
                                  //call the built-in handleChange for formik
                                  handleBlur(e);
                                  //and do something about e
                                  const answer3Val =
                                    e.currentTarget.value.trim();
                                  setFieldValue('answer3', answer3Val);
                                },
                                onChange: (e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                },
                                name: 'answer3',
                                id: 'answer3',
                                value: formData.answer3,
                                placeholder: '',
                                isInvalid: touched.answer3 && errors.answer3,
                              }}
                              feedBackMessage={
                                touched.answer3 && errors.answer3
                              }
                              ariaInvalid={errors.answer3 ? true : null}
                              ariaDescribedby="err_answer3"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col sm={12}>
                          <GenericButton
                            type="submit"
                            variant="primary"
                            disable={!isValid || isButtonDisable}
                            buttonDisabled={true}
                            className="float-right mt-4"
                          >
                            Continue
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  ) : null;
};

export default SecurityQuestion;
